import { Component, OnInit, OnDestroy } from '@angular/core';

import {
  Message,
  DefineRangeTypeModalPayload,
  DefineRangeTypeErrorResponse,
  StatisticalMethod,
  DefineRangeTypePayload,
  TbaRangeType,
  EditRangeTypePayload
} from '../../../shared/models';

import { ModalService, ConfirmationModalComponent } from '../../../shared/modules/modal';

import { RangeTypesService, NotificationService } from '../../../shared/services';
import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';

@Component({
  selector: 'define-range-type',
  templateUrl: './range-type-modal.component.html',
})
export class RangeTypeModalComponent extends ClosableModalWithErrorResponseModel<DefineRangeTypeErrorResponse>
  implements OnInit, OnDestroy {

  data: DefineRangeTypeModalPayload;
  statisticalMethods: StatisticalMethod[];
  rangeType: TbaRangeType = new TbaRangeType();

  constructor(
    protected modalService: ModalService,
    protected notificationsService: NotificationService,
    private _rangeTypesService: RangeTypesService
  ) {
    super(notificationsService, modalService);
    this.validationErrors = new DefineRangeTypeErrorResponse();
  }

  ngOnInit(): void {
    this.getStatisticalMethods();

    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  close(form = null): void {
    if (form && form.form.touched) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Close Transaction',
          content: 'Are you sure you want to cancel your actions and close it?',
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    if (this.data.rangeType) {
      this.updateRangeType();
      return;
    }

    this.saveRangeType();
  }

  resetNameValidationErrorMessage(): void {
    this.validationErrors.name = '';
  }

  private saveRangeType(): void {
    const payload = {
      name: this.rangeType.name,
      statisticalMethod: this.rangeType.statisticalMethod.id,
      tba: this.data.tba,
    } as DefineRangeTypePayload;

    this._rangeTypesService.saveStatisticalMethod(payload).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private updateRangeType(): void {
    const payload = {
      name: this.rangeType.name,
      useForDestinationTaxJurisdiction: this.rangeType.useForDestinationTaxJurisdiction,
      useForSourceTaxJurisdiction: this.rangeType.useForSourceTaxJurisdiction,
      excluded: this.rangeType.excluded,
    } as EditRangeTypePayload;

    this._rangeTypesService.editStatisticalMethod(this.rangeType.tbaRangeTypeId, payload).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }

  private getStatisticalMethods(): void {
    this._rangeTypesService.getStatisticalMethods().subscribe((res) => {
      this.statisticalMethods = res.result.statisticalMethods;
      this.setInitialData();
    });
  }

  private setInitialData(): void {
    if (this.data.rangeType) {
      // we clone the data to kill the refference
      this.rangeType = JSON.parse(JSON.stringify(this.data.rangeType));
      this.rangeType.statisticalMethod = this.statisticalMethods.find(statisticalMethod => statisticalMethod.id === this.rangeType.statisticalMethod.id);

      return;
    }

    this.rangeType.statisticalMethod = this.statisticalMethods[0];
  }
}
